
import { useQuery } from "@tanstack/react-query";
import { 
  fetchAllBookings, 
  fetchAllClasses, 
  fetchAllUsers,
  fetchAllSubscriptions,
  getAllGiftCards
} from "@/lib/supabase";
import { useState } from "react";

export const useAdminQueries = () => {
  const [userFilter, setUserFilter] = useState('');
  const [subscriptionFilter, setSubscriptionFilter] = useState('');
  const [giftCardFilter, setGiftCardFilter] = useState('');
  
  const { data: classes, isLoading: classesLoading, error: classesError } = useQuery({
    queryKey: ['admin-classes'],
    queryFn: fetchAllClasses,
  });
  
  const { data: bookings, isLoading: bookingsLoading, error: bookingsError } = useQuery({
    queryKey: ['admin-bookings'],
    queryFn: fetchAllBookings,
  });
  
  const { data: users, isLoading: usersLoading, error: usersError } = useQuery({
    queryKey: ['admin-users'],
    queryFn: fetchAllUsers,
  });
  
  const { data: subscriptions, isLoading: subscriptionsLoading, error: subscriptionsError } = useQuery({
    queryKey: ['admin-subscriptions'],
    queryFn: fetchAllSubscriptions,
  });

  const { data: giftCardsResult, isLoading: giftCardsLoading, error: giftCardsError } = useQuery({
    queryKey: ['admin-gift-cards'],
    queryFn: getAllGiftCards,
  });
  
  const giftCards = giftCardsResult?.data;
  
  return {
    classes,
    classesLoading,
    classesError,
    bookings,
    bookingsLoading,
    bookingsError,
    users,
    usersLoading,
    usersError,
    userFilter,
    setUserFilter,
    subscriptions,
    subscriptionsLoading,
    subscriptionsError,
    subscriptionFilter,
    setSubscriptionFilter,
    giftCards,
    giftCardsLoading,
    giftCardsError,
    giftCardFilter,
    setGiftCardFilter
  };
};
